export async function disablePwaCleanup(): Promise<void> {
  if (typeof window === "undefined") return;

  const CLEANUP_KEY = "ch:pwa-cleanup-done";
  if (localStorage.getItem(CLEANUP_KEY) === "true") {
    return;
  }

  try {
    // 1. Unregister PWA service workers, preserving FCM service worker
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        const scriptUrl = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL || "";
        if (scriptUrl && !scriptUrl.includes("firebase-messaging-sw.js")) {
          await reg.unregister();
          console.warn(`[PWA Cleanup] Unregistered PWA service worker: ${scriptUrl}`);
        }
      }
    }

    // 2. Clear all cache storage
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
      console.warn("[PWA Cleanup] Cleared all runtime caches successfully.");
    }

    // Mark as completed so it runs only once
    localStorage.setItem(CLEANUP_KEY, "true");
  } catch (error) {
    console.warn("[PWA Cleanup] Error during PWA service worker/cache cleanup:", error);
  }
}
